module.exports = __webpack_public_path__ + "img/convergists3.e6156089.png";